import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Welcome from './pages/Welcome';
import Schedule from './pages/Schedule';
import Travel from './pages/Travel';
import Accommodation from './pages/Accommodation';
import Gifts from './pages/Gifts';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import './index.css';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = sessionStorage.getItem('wedding-authenticated') === 'true';
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  const handleAuthenticated = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen">
      <Router>
        <Routes>
          <Route path="/login" element={<Login onAuthenticated={handleAuthenticated} />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Navigation />
              <Welcome />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/schedule" element={
            <ProtectedRoute>
              <Navigation />
              <Schedule />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/travel" element={
            <ProtectedRoute>
              <Navigation />
              <Travel />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/accommodation" element={
            <ProtectedRoute>
              <Navigation />
              <Accommodation />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/gifts" element={
            <ProtectedRoute>
              <Navigation />
              <Gifts />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/faq" element={
            <ProtectedRoute>
              <Navigation />
              <FAQ />
              <Footer />
            </ProtectedRoute>
          } />
          <Route path="/contact" element={
            <ProtectedRoute>
              <Navigation />
              <Contact />
              <Footer />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </div>
  );
}

export default App;